import Image from 'next/image';
import React from 'react';
import DriverFormUpdated from './DriverFormUpdated';


function Drivers() {
  return (
    // <div>
    //   <div className='bg-secondary py-9'>
    //     <div className='font-light text-center text-xl sm:text-2xl xl:text-4xl'>Become a <b>Driver</b></div>

    //   </div>
    //   <div className="paddingClass">
    //     <div className="my-5 text-center font-light text-3xl">
    //       Please fill in the form below to apply for becoming a driver at 24/7
    //       Radio Carz
    //       <div className='text-base lg:text-xl'>
    //         Join us and become part of an exclusive group of drivers with the
    //         freedom to choose your own schedule and earn top-notch incom. Get on
    //         board today for an enriching career experience.
    //         <div className="text-left">
    //           <ul className="list-disc">
    //             <li>
    //               Our corporate accounts offer quality work you can rely on,
    //               plus all the great benefits that accompany our
    //               industry-leading service.
    //             </li>
    //             <li>Earn up to over £15,00 p/w.</li>
    //             <li>
    //               Each job is valued at an average of £26 per order – so higher
    //               earnings during peak periods every day of the week are easily
    //               achievable for full time drivers.
    //             </li>
    //             <li>Get ready to cruise into better pay today.</li>
    //           </ul>
    //         </div>
    //       </div>
    //     </div>
    //     <DriverForm />
    //   </div>
    // </div>
    <div className='bg-homeBg bg-cover bg-right-bottom bg-no-repeat'>
      <div className='bg-black/80 flex min-h-[90vh] items-center px-2 sm:px-5 md:px-20 '>
        <div className='flex items-center md:flex-row flex-col justify-between py-10'>
          <div className='md:w-[50%]' >
            <div className='text-white bg-gray px-7 py-3 rounded-3xl my-2  inline-flex text-xl'>Join Today</div>
            <div className='text-white text-4xl my-2 md:text-left text-center'>Make Money driving with 247 carz in
              Brimingham & Surrounding areas</div>
            {/* <div className='text-white/70 font-thin text-lg md:text-left text-center'>Bromsgrove, Balsall Common, Dudley, Knowle, Redditch, Solihull, Sandwall, Sutton Coldfied, Walsall & Wolverhampton</div> */}
            <div className='text-secondary '>

              <span className='text-xl font-semibold'>Bromsgrove, Balsall Common, Coventry, Dudley, Kidderminster, Knowle, Kenilworth, Leamington Spa, Lichfield, Redditch, Solihull, Sandwall, Sutton Coldfied,Tamworth, Warwick, Worcester,  Wolverhampton & Walsall </span>
            </div>
            <div className='flex sm:flex-row flex-col items-center my-5'>
              <div className='text-white  '>
                <span className='text-2xl font-semibold'>Busy Cash Office!</span>
                <div className='my-5 font-semibold text-2xl'>Join Today</div>
                <div className='text-2xl text-secondary font-semibold'>Earn Upto<br />£1000.00 Per Week</div>
              </div>
              <Image
                src={'/assets/images/carDriver.png'}
                width={500}
                height={250}
              />
            </div>
            <div className='text-secondary '>
              <div className='my-2 text-3xl font-semibold text-white'>Licensed Operator with</div>
              <span className='text-xl font-semibold'>Birmingham, Bromsgrove, Redditch, Sandwell, Solihull & Wolverhampton Councils</span>
            </div>
          </div>
          <div className='md:w-[48%]'>
            <DriverFormUpdated />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Drivers;
